<template>
  <el-dialog custom-class="max-dialog" title="产品信息" :visible.sync="dialogFormVisible" center
             :close-on-click-modal="false"  append-to-body>
    <el-form :model="form" ref="form1">
      <el-collapse v-model="activeNames">
        <el-collapse-item name="1">
          <template slot="title">
            <span>基本信息</span>
          </template>
          <el-row :gutter="24">
            <el-col :span="16">
              <el-form-item label="货品名称" :label-width="formLabelWidth">
                {{form.seedname}}
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="货品编码" :label-width="formLabelWidth">
               {{form.seedcode}}
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="16">
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item label="下单方式" :label-width="formLabelWidth">
                    <el-select v-model="form.filltemplate" placeholder="请选择" disabled style="width: 100px">
                      <el-option
                        v-for="item in ftype"
                        :key="item.value"
                        :label="item.name"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="单位" :label-width="formLabelWidth">
                    {{form.seedunit}}
                  </el-form-item>
                </el-col>
                <el-col :span="8" style="margin-top: 6px">
                  <span v-show="isdeliverShow" style="color: red;size: 20px;margin-left:119px; ">{{this.opdates}}</span>
                </el-col>
              </el-row>
              <el-row :gutter="20" v-if="xyraangevisible">
                <el-col :span="8">
                  <el-form-item label="球镜开始度数" :label-width="formLabelWidth" >
                    {{form.YStart}}
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="球镜结束度数" :label-width="formLabelWidth">
                    {{form.YEnd}}
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="禁用0.25球镜" :label-width="formLabelWidth">
                    <el-checkbox v-model="packagesize.DisabledY25" :precision='2'></el-checkbox>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20" v-if="xyraangevisible">
                <el-col :span="8">
                  <el-form-item label="柱镜开始度数" :label-width="formLabelWidth" >
                    {{form.XStart}}
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="柱镜结束度数" :label-width="formLabelWidth">
                    {{form.XEnd}}
                  </el-form-item>
                </el-col>
                <el-col :span="3">
                  <el-form-item label="禁用0.25柱镜" :label-width="formLabelWidth">
                    <el-checkbox v-model="packagesize.DisabledX25" :precision='2'></el-checkbox>
                  </el-form-item>
                </el-col>
                <el-col :span="5">
                  <el-form-item label="联合光度" :label-width="formLabelWidth">
                    {{packagesize.Union}}
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20" v-if="form.filltemplate=='80'" :key="index" v-for="(item,index) in goodsframe">
                <el-col :span="6">
                  <el-form-item label="型号" :label-width="formLabelWidth">
                    {{item.model}}
                  </el-form-item>
                </el-col>
                <el-col :span="14">
                  <el-form-item label="规格" :label-width="formLabelWidth" >
                    {{item.color}}
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="16">
                  <el-form-item label="备注" :label-width="formLabelWidth">
                    {{form.remark}}
                  </el-form-item>
                </el-col>
              </el-row></el-col>
            <el-col :span="8">
              <el-row :gutter="20">
                <el-col :span="10">
                  <el-form-item label="展示图" :label-width="formLabelWidth" >
                    <el-image :src="form.advertisementpicture" style="width: 200px; height: 200px"></el-image>
                  </el-form-item>
                </el-col>
              </el-row></el-col>
          </el-row>
        </el-collapse-item>
        <el-collapse-item name="2">
          <template slot="title">
            <span>属性信息</span>
          </template>
          <el-row>
            <el-col :span="8">
              <el-form-item label="查询条件" :label-width="formLabelWidth" prop="queryproperty">
                <table cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;width:300px;"
                       class="query-table">
                  <tr>
                    <td style="width:100px;background-color: #F4F4F4;  " class="center">查询名称</td>
                    <td style="background-color: #F4F4F4;  text-align: center;">查询内容</td>
                  </tr>
                  <tr v-for="(item1,index) in query">
                    <td class="content">
                      {{item1.name}}
                    </td>
                    <td class="content">
                      <el-select v-model="item1.item" placeholder="请选择" :clearable="true">
                        <el-option v-for="(item2,index) in item1.categoryitems"
                                   :key="index"
                                   :label="item2"
                                   :value="item2">
                        </el-option>
                      </el-select>
                    </td>
                  </tr>
                </table>
              </el-form-item>
            </el-col>
            <el-col :span="16">
              <el-form-item label="表单属性" :label-width="formLabelWidth">
                <table cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;width:100%;"
                       class="formp-table">
                  <tr class="header">
                    <td style="width:100px;background-color: #F4F4F4;">
                    </td>
                    <td style="width:40px;background-color: #F4F4F4;" class="center">必填</td>
                    <td style="background-color: #F4F4F4;  text-align: center;">内容</td>
                  </tr>
                  <tr v-for="(item1,index) in formp">
                    <td class="content">
                      <el-checkbox v-model="item1.ischecked" style="width: 10px" >
                        {{item1.name}}
                      </el-checkbox>
                    </td>
                    <td class="content center">
                      <el-checkbox v-model="item1.required" style="width: 10px"></el-checkbox>
                    </td>
                    <td class="content">
                      <el-checkbox-group v-model="item1.item">
                        <el-checkbox v-for="small in item1.categoryitems" :label="small"
                                     :key="small">
                          {{small}}
                        </el-checkbox>
                      </el-checkbox-group>
                    </td>
                  </tr>
                </table>
              </el-form-item>
            </el-col>
          </el-row>
        </el-collapse-item>
        <el-collapse-item name="3">
          <template slot="title">
            <span>产品简介</span>
          </template>
          <el-row>
            <el-col :span="24">
              <el-form-item prop="description">
             <div v-html="form.description"></div>
              </el-form-item>
            </el-col>
          </el-row>
        </el-collapse-item>
      </el-collapse>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
    </div>
  </el-dialog>
</template>


<script>
  import {edit4Supply as getDetail, getListData, getGoodsTree} from '@/api/set/jxcgooddetail';
  import {getform as getCategoryFormDetail, getquery  as getCategoryDetail} from '@/api/set/jxcgoodscategory';

  export default {
    name: "JxcgooddetailDetail",
    data() {
      return {
        xyraangevisible: false,
        isdisabled: false,
        loading:false,
        dialogFormVisible: false,
        isr: true,
        activeNames: ['1', '2', '3', '4','5'],
        st: [],
        query: [],
        formp: [],
        seedcode: '',
        isdeliverShow: '',
        categoryname: '',
        opdates: '',
        checkall: false,//表单属性全选
        issetup: false,//新增时不现实设置按钮
        goodsframe: [],//镜架属性
        ftype: [
          {
            value: '10',
            name: "现片"
          },
          {
            value: '30',
            name: "区分左右眼"
          },
          {
            value: '20',
            name: "定制"
          },
          {
            value: '80',
            name: "镜架"
          },{
            value: '50',
            name: "加工"
          }, {
            value: '60',
            name: "特殊加工"
          },
          {
            value: '40',
            name: "数量选择"
          },
        ],
        packagesize: {
          XStart: '',
          XEnd: '',
          XSpace: 0.25,
          YStart: '',
          YEnd: '',
          YSpace: 0.25,
          DisabledX25: false,
          DisabledY25: false,
          Union: ''
        },//光度范围
        signs:[],
        form: {  //表单数据
          unitguid: '',
          tenantid:'',
          XStart: '',
          XEnd: '',
          YStart: '',
          YEnd: '',
          seedcode: '',
          goodsboms:'',
          categorycode: '',
          filltemplate: '40',
          seedname: '',
          seedunit: '',
          packagesize: '',
          unittranslate: '',
          bigseedunit: '',
          pricetype: 1,
          seedtype: '',
          seedbarcode: '',
          maxstore: '',
          minstore: '',
          maxbuyprice: '',
          refbuyprice: '',
          minsellprice: '',
          refsellprice: '',
          costprice: '',
          bom: 0,
          enabled: 1,
          queryproperty: '',
          formproperty: '',
          remark: '',
          opdate: '',
          advertisementpicture: '',
          advertisement: "",
          description: '',
          signs:'',
          sortnum: 0,
          nostock: -1,
          noscancode: -1,//扫码出入库
          relatedcategory: '',//类别关联
          relatedcategoryname: '',
          imgrandom:'',
          goodsframe: ''//镜架属性
        },
        controlData: {//绑定的控件数据，例如下拉框、复选框，单选按钮组等。
          xl: [],
          salarymode: [],
          paystyle: [],
          salarygroup: [],
          sex: [],
          status: []
        },
        formLabelWidth: '120px',
        types: [{
          label: '单选'
        }, {
          label: '多选'
        }, {
          label: '填空'
        }, {
          label: '页面选择'
        }
        ],
        isp: [{
          label: '是'
        }, {
          label: '否'
        }
        ]
      }
    },
    methods: {
      bindGoodsframe() {
        this.goodsframe = [];
        if (this.form.goodsframe && this.form.goodsframe != '[]') {
          this.goodsframe=JSON.parse(this.form.goodsframe)
        }
      },
      show() {
        this.dialogFormVisible = true;
      },
      initQuery(thedata) {
        this.query=[]
        getCategoryDetail({categorycode: this.form.categorycode,tenantid:this.form.tenantid}).then(response => {
          if (response.data.obj && response.data.obj.queryproperty != 'null' && response.data.obj.queryproperty != '') {
            let temp = JSON.parse(response.data.obj.queryproperty);
            for (let i in temp) {
              let value = ""
              if (thedata) {
                let filter1 = thedata.filter((item) => {
                  return item.name == temp[i].name
                })
                if (filter1 && filter1.length > 0) {
                  value = filter1[0].item
                }
              }

              if (!temp[i].item) {
                temp[i].item = ""
              }
              this.query.push({
                name: temp[i].name,
                categoryitems: (temp[i].item.trim().charAt(temp[i].item.trim().length - 1) == ";" ? temp[i].item.trim().substr(0, temp[i].item.trim().length - 1) : temp[i].item.trim()).split(';'),
                item: value
              })
            }
          }
        })
      },
      initFormProperty(thedata) {
        this.formp=[]
        getCategoryFormDetail({categorycode: this.form.categorycode,tenantid:this.form.tenantid}).then(response => {
          if (response.data.obj && response.data.obj.formproperty != 'null' && response.data.obj.formproperty != '') {
            let temp = JSON.parse(response.data.obj.formproperty);
            this.checkall = true
            for (let i in temp) {
              let checked1 = false, value1 = [], required = false
              if (thedata) {
                let filter1 = thedata.filter((item) => {
                  return item.name == temp[i].name
                })
                if (filter1 && filter1.length > 0) {
                  checked1 = true
                  if (typeof(filter1[0].item) == "string") {
                    value1 = filter1[0].item.trim().split(';').filter((tt) => {
                      return tt != ""
                    })
                  }
                  required = filter1[0].required
                }
              }
              if (!checked1) {
                this.checkall = false
              }
              let items = temp[i].item ? temp[i].item.trim().split(';').filter((tt) => {
                return tt != ""
              }) : []
              this.formp.push({
                name: temp[i].name,
                item: value1,
                ischecked: checked1,
                required: required,
                categoryitems: items,
                edittype: temp[i].edittype,
                ispublic: temp[i].ispublic
              })
            }
          }
        })
      },
      initData(row) {
        //this.initForm()
        this.issetup = true;
        getDetail({seedcode: row.seedcode,tenantid:row.tenantid}).then(response => {
          this.isdisabled = true;
          this.isr = false;
          if (response.data.obj.categoryname) {
            this.categoryname = response.data.obj.categoryname;
          } else {
            this.categoryname = '';
          }

          for (let i in this.form) {
            this.form[i] = response.data.obj[i];
          }
          this.bindGoodsframe();

          this.xyraangevisible = this.form.filltemplate != "40" && this.form.filltemplate != "50" && this.form.filltemplate != "60"&& this.form.filltemplate != "80";;

          if (this.form.packagesize && this.form.packagesize != '') {
            this.packagesize = JSON.parse(this.form.packagesize)
            if (typeof this.packagesize.DisabledY25 == "undefined") {
              this.$set(this.packagesize, "DisabledY25", false)
            }
            this.form.XStart = this.packagesize.XStart
            this.form.XEnd = this.packagesize.XEnd
            this.form.YStart = this.packagesize.YStart
            this.form.YEnd = this.packagesize.YEnd
          } else {
            this.packagesize = {
              XStart: '',
              XEnd: '',
              XSpace: 0.25,
              YStart: '',
              YEnd: '',
              YSpace: 0.25,
              DisabledX25: false,
              DisabledY25: false,
              Union: ''
            }
            this.form.XStart = 0
            this.form.XEnd = 0
            this.form.YStart = 0
            this.form.YEnd = 0
          }

          if (this.form.seedtype) {
            this.st = JSON.parse(this.form.seedtype);
          }

          if (response.data.obj.queryproperty && response.data.obj.queryproperty != 'null' && response.data.obj.queryproperty != '') {
            this.initQuery(JSON.parse(response.data.obj.queryproperty))
          } else {
            this.initQuery()
          }
          if (response.data.obj.formproperty && response.data.obj.formproperty != 'null' && response.data.obj.formproperty != '') {

            this.initFormProperty(JSON.parse(response.data.obj.formproperty))
          } else {
            this.initFormProperty()
          }

          if (response.data.obj.opdate) {
            this.isdeliverShow = true;
            this.opdates = "下架日期(" + response.data.obj.opdate.substring(0, 10) + ")";
          } else {
            this.isdeliverShow = false;
          }
          this.form.seedcode = seedcode
        })
      },
      initForm() {
        this.checkall = false
        this.xyraangevisible = false
        //this.form.filltemplate = '40'
        this.signs=[]
        this.formp = [];
        this.query = []
        this.opdates = '';
        this.st = [];
        this.isdisabled = false;
        this.isr = true;
        this.form.unitguid = ''
        this.rules = Object.assign(this.rules, this.seedcode);
        if (this.$refs.form1 !== undefined) {
          this.$refs.form1.resetFields();
        }
        this.form.advertisement = "";
        this.form.categorycode = this.guid[0];
        this.categoryname = this.guid[1];
        this.packagesize = {
          XStart: '',
          XEnd: '',
          XSpace: 0.25,
          YStart: '',
          YEnd: '',
          YSpace: 0.25,
          DisabledX25: false,
          DisabledY25: false,
          Union: ''
        }
        this.form.XStart = ''
        this.form.XEnd = ''
        this.form.YStart = ''
        this.form.YEnd = ''
        this.form.relatedcategory = ''
        this.form.relatedcategoryname = ''
        this.form.goodsframe=""
        this.form.nostock=-1
        this.bindGoodsframe()
      },
    },
    components: {
    },
    mounted() {
    }
  }
</script>

<style scoped>
  .query-table td {
    border: 1px solid #E0DFDF;
    vertical-align: center;
    height: 40px;
    line-height: 40px;
    padding: 2px;
  }

  .query-table td.content {

  }

  .formp-table .header td {
    border: 1px solid #E0DFDF;
    vertical-align: center;
    height: 40px;
    line-height: 40px;
    padding: 2px;
  }

  .formp-table td.content {
    border: 1px solid #E0DFDF;
    vertical-align: center;
    height: 25px;
    line-height: 25px;
    padding: 2px;
  }

  .center {
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/set/jxcgooddetail/JxcgooddetailDetail.vue